import React from "react";
import PropTypes from "prop-types";
import { EntityIcon } from "../../Layouts/Icon";
import { openIconDetail, closeIconDetail } from "../../Actions/iconDetailAction";
import { iconLabel } from "../../utils/svgIcon";

export const IconTile = ({ entity, isActive, inCollection, dispatch }) => {
  // Duotone icons are two glyphs; only the visible ("before") one gets a tile
  if (entity.isDuotone && entity.assign === "after") return null;

  const label = iconLabel(entity.name);

  return (
    <div className="icon-box">
      <div
        className={`icon${isActive ? " active" : ""}${inCollection ? " icon-selected-state" : ""}`}
        data-id={entity.id}
        data-class={entity.name}
      >
        <button
          type="button"
          className="icon__open"
          // Clicking the open icon again closes the detail panel
          onClick={() => dispatch(isActive ? closeIconDetail() : openIconDetail(entity))}
          aria-label={entity.isDuotone ? `${label}, duotone` : label}
          title={label}
        >
          <EntityIcon entity={entity} />
          <span className="icon__name">{label}</span>
        </button>
      </div>
    </div>
  );
};

IconTile.propTypes = {
  entity: PropTypes.any,
  isActive: PropTypes.bool,
  inCollection: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
};

export default IconTile;
